import { render, staticRenderFns } from "./InstantGolfRounds.vue?vue&type=template&id=bb88a4ca&scoped=true&"
import script from "./InstantGolfRounds.vue?vue&type=script&lang=js&"
export * from "./InstantGolfRounds.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./InstantGolfRounds.vue?vue&type=style&index=1&id=bb88a4ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb88a4ca",
  null
  
)

export default component.exports